module.exports = __webpack_public_path__ + "img/focus-analytics.eb3130af.png";